(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["merdello-autoplay-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('merdello-autoplay-video')) {
  customElements.define('merdello-autoplay-video', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.manualPaused = false;
      this.manualPlay = false;
      this.pending = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.sync = () => {
        const wantsPlay = this.visible && !document.hidden && !this.manualPaused && (!this.motion.matches || this.manualPlay);
        if (!wantsPlay) {
          this.video.pause();
          if (this.visible && (this.manualPaused || this.motion.matches)) this.showPlay();
          return;
        }
        if (this.pending || !this.video.paused) return;
        const sources = this.video.querySelectorAll('source[data-src]');
        sources.forEach(source => { source.src = source.dataset.src; source.removeAttribute('data-src'); });
        if (sources.length) this.video.load();
        this.pending = true;
        let interrupted = false;
        const result = this.video.play();
        Promise.resolve(result).catch(error => {
          interrupted = error.name === 'AbortError';
          if (!interrupted && this.visible) this.showPlay();
        }).finally(() => {
          this.pending = false;
          if (interrupted && this.isConnected && this.visible && !document.hidden && !this.manualPaused) this.sync();
        });
      };
      this.button.addEventListener('click', () => {
        this.manualPaused = !this.video.paused;
        this.manualPlay = !this.manualPaused;
        this.sync();
      }, options);
      this.video.addEventListener('playing', () => {
        if (!this.visible || document.hidden || this.manualPaused) { this.video.pause(); return; }
        this.removeAttribute('data-needs-play');
        this.button.setAttribute('aria-label', this.dataset.pauseLabel);
      }, options);
      this.video.addEventListener('error', () => this.showPlay(), options);
      this.video.addEventListener('canplay', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      window.addEventListener('pageshow', this.sync, options);
      window.addEventListener('pagehide', () => this.video.pause(), options);
      this.motion.addEventListener('change', this.sync, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { this.visible = entry.isIntersecting && entry.intersectionRatio >= .15; });
          this.sync();
        }, { threshold: [0, .15] });
        this.observer.observe(this);
      } else {
        this.visible = true;
        this.sync();
      }
    }
    showPlay() {
      this.setAttribute('data-needs-play', '');
      this.button.setAttribute('aria-label', this.dataset.playLabel);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
      this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
